import {Component, OnInit, Output, EventEmitter, ChangeDetectorRef, HostListener, DoCheck} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from '../../base/base.component';
import { PermissionConfig } from 'src/app/core/constants/permission-config';
import { Message } from 'src/app/core/class/message';
import { AuthService } from 'src/app/core/auth/auth.service';
import { MatDialog, DateAdapter } from '@angular/material';
import { ChangePasswordComponent } from '../../change-password/change-password.component';
import { ReloadEventEmitterService } from 'src/app/core/services/reload-event-emitter.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { environment } from '../../../../../environments/environment';
import { Notify, NotifyAlertComponent } from '../notify-alert/notify-alert.component';
import { NotifyService } from '../../../../core/services/notify.service';
import { EnvService } from '../../../../core/services/env.service';
import { Process } from '../processing-header/processing.component';
import { FeedbackComponent } from '../../feedback/feedback.component';
import { ToastrService } from 'ngx-toastr';
import { SelectVersionComponent } from '../../../../shared/components/select-version/select-version.component'

declare var SockJS;
declare var Stomp;
const URL_DIGITAL_CERTIFICATE_DEFAULT = '/home-enterprise/default';
declare var $: any; // ADD THIS
import * as $ from 'jquery';
import {ChangePassswordFirsrtTimeComponent} from "../../change-passsword-firsrt-time/change-passsword-firsrt-time.component";
import {NotificationCmsService} from '../../../../core/services/notification-cms.service';
import { DowloadAppMobileComponent } from '../../dowload-app-mobile/dowload-app-mobile.component';
import { ResourceComponent } from '../../resource/resource.component';
import { EnterpriseConfigService } from 'src/app/core/services/enterprise-config.service';
import { MysignSessionConfiguration } from '../../mysign-session-configuration/mysign-session-configuration.component';
import { HeaderCountService } from 'src/app/core/services/header-count.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

/*
 * <pre>
 * <b>Class name: HeaderComponent</b>
 * <b>Explanation:</b> Component header for enterprise
 * <b>Creation date:</b> 2019/08/25
 * </pre>
 *
 * @author GCS 2019/07/01 by linhdh
 **/
export class HeaderComponent extends BaseComponent implements OnInit, DoCheck {

  userType: any;
  token: string;
  permissions: any;
  isPermisEnterprise: boolean;
  isPermisInfoEnterprise: boolean;
  userName = localStorage.getItem('userName');
  fullName = localStorage.getItem('fullName');
  showSpecialLogo = this.userName ? (this.userName.includes('0102912566') || this.userName.includes('0100681592') || this.userName.includes('6000000000')) : false;
  langCurrent = this.getLanguagelocalStored();
  isShowSideBarMenu = false;
  isFromSSO = false;

  panelOpenState = false;

  isNotAttestedUser = false;
  showChangeVersion = false;
  isExpaned = true;

  openMenu(e:Event){
    document.getElementById('sidebarToggle').click();
    this.isExpaned = localStorage.getItem('SidebarCurrentStatus')=='Collapsed'?false:true
  }

  // uer type
  userSysAdminType = PermissionConfig.USER_SYS_ADMIN_TYPE;
  userEnterpriseAdminType = PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE;
  userEnterpriseStaffType = PermissionConfig.USER_ENTERPRISE_STAFF_TYPE;
  userEnterpriseCustomerType = PermissionConfig.USER_ENTERPRISE_CUSTOMER_TYPE;

  // feature groups
  enAdminEnterpriseInfoManage = PermissionConfig.EN_ADMIN_ENTERPRISE_INFO_MANAGE;
  enAdminCetificateManage = PermissionConfig.EN_ADMIN_CETIFICATE_MANAGE;
  enAdminBranchManage = PermissionConfig.EN_ADMIN_BRANCH_MANAGE;
  enAdminGroupUserManage = PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE;
  enAdminUserManage = PermissionConfig.EN_ADMIN_USER_MANAGE;
  enAdminMaterialSampleManage = PermissionConfig.EN_ADMIN_MATERIAL_SAMPLE_MANAGE;
  enAdminCustomerManage = PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE;
  enAdminMaterialManage = PermissionConfig.EN_ADMIN_MATERIAL_MANAGE;
  sysAdminEnterpriseInfoManage = PermissionConfig.SYS_ADMIN_ENTERPRISE_INFO_MANAGE;
  sysAdminUserManage = PermissionConfig.SYS_ADMIN_USER_MANAGE;
  sysAdminMaterialSampleManage = PermissionConfig.SYS_ADMIN_MATERIAL_SAMPLE_MANAGE;

  public serverUrl = this.env.notify_service;
  public ws = new SockJS(this.serverUrl);
  public stompClient = Stomp.over(this.ws);
  notifies: Notify[] = [];
  totalUnread: number;
  processes: Process[] = [];
  userServices = JSON.parse(localStorage.getItem('userServices') || '[]')
  private dialogRef: any;
  chooseVersion = undefined
  connected2TypesAccounts = false
  srcLogo: string
  isShowToggleBar: boolean
  isShowMenuInfoUseResource: boolean = false;
  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event) {
    // Xử lý sự kiện popstate khi người dùng ấn nút "Back" hoặc "Next" trên trình duyệt
    // Thực hiện các hành động tương ứng, có thể cập nhật currentIndex từ URL hoặc nguồn dữ liệu khác.
    this.changePasswordFirstTime()
  }
  /**
   * <pre>
   * <b>Method name: constructor</b>
   * <b>Explanation: </b> Method constructor
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  constructor(
    public commonService: CommonService,
    public router: Router,
    private auth: AuthenticationService,
    private translate: TranslateService,
    private authService: AuthService,
    public message: Message,
    private dialog: MatDialog,
        private _adapter: DateAdapter<any>,
    private reloadEventEmitterService: ReloadEventEmitterService,
    public deviceService: DeviceDetectorService,
    private notifyService: NotifyService,
    private toastr: ToastrService,
    private env: EnvService,
    private cd: ChangeDetectorRef,
    private enterpriseConfigService: EnterpriseConfigService,
    private headerCountService: HeaderCountService
  ) {
    super(commonService, message);
    this.userType = localStorage.getItem('userType');
    this.token = this.authService.getToken();
    this.permissions = localStorage.getItem('permissions');
    this.showPermisInfoEnterprise();
    this.showPermisEnterprise();
    // hiện ngay số cũ từ cache để badge không nháy về rỗng khi chuyển tab
    if (this.headerCountService.notifies !== null) {
      this.notifies = this.headerCountService.notifies;
      this.totalUnread = this.headerCountService.totalUnread;
    }
    this.notifyService.getLastedNotify().subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      // chỉ gán lại UI khi số mới khác cache -> số không đổi thì badge đứng yên, không nháy
      if (this.headerCountService.setNotifyData(rs.data.notificationDTO, rs.data.totalUnread)) {
        this.notifies = rs.data.notificationDTO;
        this.totalUnread = rs.data.totalUnread;
      }
    });
    this.isFromSSO = JSON.parse(localStorage.getItem('isFromSSO'));
    this.isNotAttestedUser = this.commonService.checkEnterpriseType()
    if (this.isNotAttestedUser){
      this.chooseVersion = 2
      this.srcLogo ='../../../../../assets/images/logo_scontract_w.png'
    }
    else{
      this.chooseVersion = 1
      this.srcLogo ='../../../../../assets/images/logo_vcontract_w.png'
    }

    if (this.userServices.length >= 2) this.connected2TypesAccounts = true
  }
  ngDoCheck(): void {
    const a= document.getElementById('toggleBar') as HTMLInputElement;
    this.isShowToggleBar = a.clientWidth > 0 ? true : false
  }

  @Output() changeLanguage = new EventEmitter<boolean>();
  @Output() someEvent = new EventEmitter();

  ngOnInit() {
    if (this.deviceService.isMobile()) {
      this.isShowSideBarMenu = true;
    }
    const isFromSSO  = localStorage.getItem('isFromSSO')
    if (isFromSSO == 'false') {
      this.dialog.closeAll();
      this.changePasswordFirstTime();
    }
    this.initializeWebSocketConnection();
    this.checkUseResource();
    // them phan xu ly icon cua header
    this.isExpaned = localStorage.getItem('SidebarCurrentStatus')=='Collapsed'?false:true;
  }

  ngAfterViewInit() {
    $('body').on('click', '.dropdown-menu', function (e) {
      $(this).parent().is(".show") && e.stopPropagation();
    });
    // $('body').on('click', function () {
    //   const dropdownMenu = document.getElementById('header-dropdown-menu');
    //   if (dropdownMenu) {
    //     setTimeout(()=>{
    //       if (!dropdownMenu.classList.contains('show')) {
    //         this.showChangeVersion = false;
    //         this.cd.detectChanges();
    //       }
    //       console.log('this.showChangeVersion', this.showChangeVersion);
    //     }, 1000)
    //   }
    // })
  }

  checkUseResource() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    // dùng cache chung: header bị tạo lại sau mỗi lần chuyển tab (routeReuseStrategy=false)
    // nếu fetch trực tiếp sẽ gọi lại API mỗi lần navigate
    this.enterpriseConfigService.getResources(enterpriseId).subscribe((rs) => {
      if (rs && rs.code == 200) {
        if(rs && rs.data && rs.data.length) {
          this.isShowMenuInfoUseResource = true;
        } else {
          this.isShowMenuInfoUseResource = false;
        }
      } else {
        this.isShowMenuInfoUseResource = false;
      }
    });
  }

  setShowChangeToDefault() {
    this.showChangeVersion = false;
  }

  initializeWebSocketConnection() {
    const currentUser = localStorage.getItem('token') || sessionStorage.getItem('token');
      this.stompClient.connect({ token: currentUser }, () => {
        this.stompClient.subscribe('/users/topic/app-messages', (message) => {
          if (message) {
            let parsed_msg = JSON.parse(message.body)
            if(parsed_msg.eventType == 'ADD' || parsed_msg.eventType == undefined){
              this.notifies.unshift(parsed_msg)
              this.notifies = this.notifies.slice(0, this.notifies.length - 1)
              this.totalUnread++;
            } else if (parsed_msg.eventType == 'SUB') {
              this.notifies = this
                .notifies
                .map($ => {
                  if($.id == parsed_msg.id) {
                    if($.status != parsed_msg.status) {
                      this.totalUnread--;
                    }
                    $.status = true;
                    return $;
                  } else {
                    return $;
                  }
                })
            } else if (parsed_msg.eventType == 'DEL') {
              this.notifies = this
                .notifies
                .filter($ => $.id != parsed_msg.id);
            }
          }
        });
      }, (error) => {
        // console.log(error);
      });
    // }
  }

  updateNotification(noti: any) {
    this.notifies = noti.notifies;
    this.totalUnread = noti.totalUnread;
  }

  swapMenu() {
    this.showChangeVersion = !this.showChangeVersion
  }

  chooseVersionChange() {
    let scopeTypeChoose = this.userServices.find(x => x.scopeType == this.chooseVersion)
    const dataUpdate = {
      id: scopeTypeChoose ? scopeTypeChoose.id : ''
    }
    this.auth.changeMode(dataUpdate).subscribe(result => {
      if (result && result.data && result.success) {
        sessionStorage.setItem('isChangeMode', 'true')
        localStorage.setItem("permissions", JSON.stringify(result.data.permissions));
        localStorage.setItem('isParent', result.data.isParent);
        localStorage.setItem('isAdminDefault', result.data.isAdminDefault);
        localStorage.setItem('userType', result.data.userType);
        localStorage.setItem('isLocked', result.data.isLocked);
        if (result.data.entType !== undefined) {
          localStorage.setItem('entType', result.data.entType);
        } else {
          localStorage.removeItem('entType');
        }
        setTimeout(() => {
          window.location.href = '/home-enterprise/analysis-report'
        }, 500);
      } else {
        this.toastr.error(
          this.commonService.format(this.message.getMessage('select_version.message.change_mode_failed'), this.isNotAttestedUser ? 'vContract' : 'sContract')
        )
      }
    })
  }

  changeDefaultVersion() {
    this.dialogRef = this.dialog.open(SelectVersionComponent, {
      width: '40%',
      disableClose: true,
      data: {
        userServices: this.userServices,
        isLogin: false
      }
    });
    this.dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        // sessionStorage.setItem('isChangeDefaultMode', 'true')
        // localStorage.setItem("permissions", JSON.stringify(result.data.permissions));
        // localStorage.setItem('isParent', result.data.isParent);
        // localStorage.setItem('isAdminDefault', result.data.isAdminDefault);
        // localStorage.setItem('userType', result.data.userType);
        // if (result.data.entType !== undefined) {
        //   localStorage.setItem('entType', result.data.entType);
        // } else {
        //   localStorage.removeItem('entType');
        // }
        // setTimeout(() => {
        //   window.location.href = '/home-enterprise/analysis-report'
        // }, 500);
        localStorage.setItem('userServices', JSON.stringify(result.data.userService.userServices || []))
        this.toastr.success(this.message.getMessage('select_version.message.change_default_mode_success'))
      } else if (result && !result.success) {
        this.toastr.error(this.message.getMessage('select_version.message.change_default_mode_failed'))
      } else {
        this.panelOpenState = false
      }
    })
  }

  /**
   * <pre>
   * <b>Method name: logout</b>
   * <b>Explanation: </b> Method logout
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  logout() {
    this.ws.close();
    this.stompClient.disconnect();
    localStorage.setItem('sockJsConnected', '');
    this.headerCountService.reset();
    this.auth.logout();
    this.router.navigate(['enterprise-login']);
  }

  navigateProcedure() {
    this.router.navigate(['home-enterprise/usr-procedure-management']);
  }

  /**
   * <pre>
   * <b>Method name: onChangeLanguage</b>
   * <b>Explanation: </b> Method setting change langauge
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  onChangeLanguage(languageSelected: string) {
    this.activateClassLanguage(languageSelected)
    this.setLanguagelocalStored(languageSelected);
    this._adapter.setLocale(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
    this.reloadEventEmitterService.onAnalysisReportEnterpriseFunction();
    this.commonService.setCurrentLanguage(languageSelected);
  }

  /**
   * <pre>
   * <b>Method name: showPermisInfoEnterprise</b>
   * <b>Explanation: </b> Method setting enterprise info menu
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  showPermisInfoEnterprise() {
    if (this.userType == null || this.permissions == null || this.userType == undefined || this.permissions == undefined) {
      this.isPermisEnterprise = false;
    } else {
      if (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE
        || this.permissions.includes(PermissionConfig.EN_ADMIN_BRANCH_MANAGE)
        || this.permissions.includes(PermissionConfig.EN_ADMIN_GROUP_USER_MANAGE)
        || this.permissions.includes(PermissionConfig.EN_ADMIN_USER_MANAGE)) {
        this.isPermisEnterprise = true;
      } else {
        this.isPermisEnterprise = false;
      }
    }
  }

  /**
   * <pre>
   * <b>Method name: showPermisEnterprise</b>
   * <b>Explanation: </b> Method setting enterprise menu
   * </pre>
   * @author GCS 2019/08/25 by linhdh
   *
   */
  showPermisEnterprise() {
    if (this.userType == null || this.permissions == null || this.userType == undefined || this.permissions == undefined) {
      this.isPermisEnterprise = false;
    } else {
      if (this.userType == PermissionConfig.USER_ENTERPRISE_ADMIN_TYPE || this.userType == PermissionConfig.USER_ENTERPRISE_STAFF_TYPE
        || this.permissions.includes(PermissionConfig.EN_ADMIN_ENTERPRISE_INFO_MANAGE)
        || this.permissions.includes(PermissionConfig.EN_ADMIN_CUSTOMER_MANAGE)) {
        this.isPermisInfoEnterprise = true;
      } else {
        this.isPermisInfoEnterprise = false;
      }
    }
  }
  // hiepnh Dialog change pass first time
  changePasswordFirstTime() {
    const lastChangePasss  = localStorage.getItem('lastChangePassword');
    console.log(lastChangePasss)
    if (!lastChangePasss || lastChangePasss === 'null' || lastChangePasss=== 'undefined' ) {
      this.dialog.closeAll();
      const dialogRef = this.dialog.open(ChangePassswordFirsrtTimeComponent, {
        width: this.deviceService.isMobile() ? '100%' : '50%',
        maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
        panelClass: 'scontract-overlay-dialog'
      });
      dialogRef.afterClosed().subscribe(() => {
      });
    }
  }

  /**
   * Open change password dialog
   */
  changePassword() {
    document.getElementById('toggleBar').click();
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: this.deviceService.isMobile() ? '100%' : '50%',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  showModalDowloadApp() {
    document.getElementById('toggleBar').click();
    const dialogRef = this.dialog.open(DowloadAppMobileComponent, {
      width: this.deviceService.isMobile() ? '100%' : '50%',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '30vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  activateClassLanguage(lang) {
    this.langCurrent = lang;
  }

  changeDigitalCertificate() {
    this.router.navigate([URL_DIGITAL_CERTIFICATE_DEFAULT]);
  }

  openPopupFeedback() {
    this.dialog.open(FeedbackComponent, {
      panelClass: ['w-50', 'pb-2'],
      disableClose: true
    })
  }

  openPopupUseRecources() {
    this.dialog.open(ResourceComponent, {
      panelClass: ['w-75', 'pb-2'],
      disableClose: true
    })
  }

  navigateLinkGoogleAccount() {
    this.router.navigate(['home-enterprise/connect-account']);
  }

  configSaveMySignSession(){
    const dialogRef = this.dialog.open(MysignSessionConfiguration, {
      width: '500px',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
    });
  }

  getCurrentNameLanguage(): string{
    switch(this.langCurrent){
      case 'vi':
        return 'Tiếng Việt';
      case 'en':
        return 'English';
      case 'zh':
        return '中国人';
      case 'es':
        return 'Español';
      default:
        return 'Tiếng Việt'
    }
  }
  isOpen: boolean = false;
}
